<template>
  <div :class="className">
    <input
      type="text"
      class="form-control broder"
      :placeholder="placeholder"
      v-model="inputVal"
      @input="this.$emit('change-input', inputVal)"
    />
    <div class="input-group-append">
      <span class="input-group-text"><i class="fas fa-search"></i></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    placeholder: String,
    className: { default: "input-group mb-3 col-3", type: String },
  },
  data() {
    return {
      inputVal: null,
    };
  },
};
</script>
